import styled from 'vue-styled-components';

import theme from '@/config/theme';

const Wrapper = styled.header`
  display: flex;
  flex-direction: column;
  background-color: ${theme.colors.white};
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05);
  height: 82px;
  position: fixed;
  width: 100%;
  z-index: 4;

  > .headerContainer {
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 1rem;
    column-gap: 1rem;

    > button {
      border-color: ${theme.colors.primaryBlue};
      left: ${theme.spacings.large};
      min-width: 32px;
    }

    > .container {
      align-items: center;
      display: flex;
      justify-content: space-between;

      > .monitoring {
        display: flex;

        > p {
          color: ${theme.colors.gray6};
          font-size: ${theme.font.sizes.p1};
          margin-right: 20px;
        }
      }
    }
  }

  > .treePath {
    display: none;
  }

  @media screen and (max-width: ${theme.grid.tablet.breakpoint}) {
    height: 121px;

    > .headerContainer {
      height: 70%;
      column-gap: 1rem;
    }

    > .treePath {
      display: flex;
      padding: 0 1rem;
    }

    > .lineCustom {
      display: block;
      width: 100%;
      background-color: #dee1db;
      height: 1px;
      margin-bottom: 0.5rem;
    }
  }
`;

export default Wrapper;
